import { ReactComponent as WorldIcon } from 'assets/bosta-icons/your-website-icon.svg';

const GOOGLE_SSO_LINK =
  window.env && window.env.SSO_LINK
    ? window.env.SSO_LINK
    : 'https://accounts.google.com/AccountChooser?continue=https://accounts.google.com/o/saml2/initsso?idpid%3DC033ka3yq%26spid%3D562239957854%26forceauthn%3Dfalse%26from_login%3D1%26as%3DQ18QEtEjl225BrYAsP0u8g&ltmpl=popup&btmpl=authsub&scc=1&oauth=1';

const BOSTA_EMAIL_SSO =
  window.env && window.env.BOSTA_EMAIL_SSO
    ? window.env.BOSTA_EMAIL_SSO
    : 'https://accounts.google.com/AccountChooser?continue=https://accounts.google.com/o/saml2/initsso?idpid%3DC03q87djb%26spid%3D400145937411%26forceauthn%3Dfalse%26from_login%3D1%26as%3DQ18QEtEjl225BrYAsP0u8g&ltmpl=popup&btmpl=authsub&scc=1&oauth=1';

export const BOSTA_EMAIL_LINKS = {
  BOSTA_CO: 'BOSTA.CO',
  BOSTA_EMAIL: 'BOSTA_EMAIL'
};

export const GOOGLE_SSO_LINKS = {
  [BOSTA_EMAIL_LINKS.BOSTA_CO]: GOOGLE_SSO_LINK,
  [BOSTA_EMAIL_LINKS.BOSTA_EMAIL]: BOSTA_EMAIL_SSO
};

export const DOMAIN_SELECTOR_OPTIONS = [
  {
    icon: <WorldIcon />,
    title: '@bosta.co / @getbosta.com',
    example: 'Ex: employee@bosta.co',
    value: BOSTA_EMAIL_LINKS.BOSTA_CO
  },
  {
    icon: <WorldIcon />,
    title: '@bosta.email',
    example: 'Ex: employee@bosta.email',
    value: BOSTA_EMAIL_LINKS.BOSTA_EMAIL
  }
];
